import { FC } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { yourJourneySelectors } from '@store/yourJourney';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { JourneyPickerV2 } from './JourneyPickerV2';
import type { JourneyPickerV2Props } from './JourneyPickerV2';

const mapStateToProps = (state) => ({
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ changeJourneyParam }, dispatch);

export const JourneyPickerV2Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyPickerV2) as FC<Omit<JourneyPickerV2Props, 'journeyParams' | 'changeJourneyParam'>>;
